import {MusicType} from "./MusicModel";
import {AbstractMusicActivity} from "./AbstractMusicActivity";
import {nyatiti} from "../../Layout/MusicScreenLayout";
import {Button} from "../Button";
import {AudioChannel} from "../../Core/AudioChannel";
import {MusicNotesEmit} from "./MusicNotesEmit";
import {InstrumentButton} from "./InstrumentButton";
import {Keyboard} from "../Keyboard";
import {HomeScreen} from "../../States/HomeScreen";

const reactionVO = [
    "LetsGoLuna_207",
    "LetsGoLuna_208"
];

export class NyatitiActivity extends AbstractMusicActivity<InstrumentButton> {

    readonly button: Button;

    constructor(screen: HomeScreen) {
        super(screen);

        nyatiti.call(this);
        this.sprite.saveTransform();

        this.button = this.sprite as any;
        this.button.enabled = false;

        const notes = this.container.addChild(new MusicNotesEmit(this.button.width * 0.2, this.button.width * 0.2));
        notes.x = this.button.x;
        notes.y = this.button.y;

        let bgmVolume = 0;
        let isDown = false;
        const onUp = () => {
            if (isDown) {
                isDown = false;
                AudioChannel.SFX.stop(`${MusicType.Nyatiti}`);
                notes.emitter.emit = false;
                AudioChannel.BGM.volume = bgmVolume;
                this.playReactionVO();
            }
        };
        this.button.onDown.add(() => {
            if (isDown) return;
            isDown = true;
            AudioChannel.SFX.play(`${MusicType.Nyatiti}`, "loop");
            notes.emitter.emit = true;
            bgmVolume = AudioChannel.BGM.volume;
            AudioChannel.BGM.volume = 0;
        });
        this.button.onUp.add(onUp);
        this.button.onOut.add(onUp);
    }

    protected getSprite(): InstrumentButton {
        return new InstrumentButton();
    }

    protected getMusicType(): MusicType {
        return MusicType.Nyatiti;
    }

    protected activate() {
        super.activate();
        this.button.enabled = true;
        Keyboard.focus(this.button);
    }

    protected deactivate() {
        this.button.enabled = false;
        super.deactivate();
    }

    protected getReactionVO(): string[] | undefined {
        return reactionVO;
    }

    protected getFactVO(): string | undefined {
        return "LetsGoLuna_pc_gn32";
    }
}